import { useAuthStore } from '@/stores/auth'

let interceptorId: number | null = null

const useProfileApiInterceptor = (profileId: string): Promise<void> => {
  return new Promise((resolve) => {
    const authStore = useAuthStore()
    const axios = authStore.axios

    if (interceptorId !== null) {
      axios.interceptors.request.eject(interceptorId)
    }

    interceptorId = axios.interceptors.request.use((config) => {
      if (profileId) {
        config.headers['X-Profile-ID'] = profileId
      }
      return config
    })

    resolve()
  })
}

export default useProfileApiInterceptor
